'use strict'

/**
 * Vue Panier
 */
import modal from 'Modules/modal'
import 'magiczoomplus'
import PanierPremiumService from 'Modules/Services/panierPremiumService'
import master from 'Modules/master'
import { InitWishListEvent } from 'Modules/wishList'
import adresse from 'Components/adresse'
import panierVendeur from 'Components/panierVendeur'
import pointRelais from 'Components/pointRelais'
import mapPointRelais from 'Components/mapPointRelais'
import { CRO } from 'Modules/cro'
import initCopyCodePromoHandler from 'Modules/bandeauPromo'
import carousel from 'Modules/carousel'
import crossSell from 'Modules/crossSell'
// /!\ Ne pas supprimer l'import. Permet l'affichage de la devise dans le composant VueJS
import filters from 'Modules/filters'

/**
 * Force le rechargement de la page si la page charge à partir du cache
 */
window.onpageshow = function (event) {
    if (event.persisted) {
        window.location.reload()
    }
}
window.mzOptions = {
    rightClick: 'true',
    zoomPosition: 'inner',
    hint: 'off',
    history: 'false' // Prévient l'ajout du hash dans l'url qui faisait perdre les paramètres de pagination sur la catalogue
}
// TEST AB
// (function () {window.IsTestABPopInActive = true}))()

/**
 * Panier (Application Vue JS)
 */
new Vue({
    el: '#panierApp',
    components: {
        adresse,
        panierVendeur,
        pointRelais,
        mapPointRelais
    },
    data: function () {
        return {
            IsInitialLoad: true,
            Panier: null,
            Script: null,
            Result: null,
            IsLoading: false,
            IsDisplayCP: false,
            CodePromo: '',
            ResultatCodePromo: null,
            ShowLineProduct: false,
            libelleShowMoreProduct: $t('VOIR_PLUS'),
            Steps: {
                Shopping: { Value: 0, Hash: '', elementId: '' },
                Livraison: {
                    Value: 1,
                    Hash: '#livraison',
                    elementId: 'basket__transaction'
                },
                PointRelais: { Value: 2, Hash: '#pointrelais', elementId: '' },
                Paiement: {
                    Value: 3,
                    Hash: '#paiement',
                    elementId: 'basketPaiement'
                },
                Recap: { Value: 4, Hash: '#recap', elementId: 'basket__total' }
            },
            AffichageLivraisons: {
                None: 0,
                Resume: 1,
                Formulaire: 2
            },
            AffichageLivraisonPanierVendeur: [],
            Step: 0,
            previousStep: -1,
            PointRelais: [],
            SelectedReferenceVendeur: null,
            RecherchePointRelais: {
                IsFirstLoad: true,
                PointRelaisType: 0,
                Adresse: '',
                CodePostal: '',
                Ville: '',
                Longitude: 0,
                Latitude: 0
            },
            SendSupprimerCommande: false,
            refVenteAsupprimer: 0,
            referencePaiement: null,
            refST: 2,
            onActivationScriptWasRun: false,
            onValidationScriptWasRun: false,
            hasError: false,
            hasErrorPointRelais: true,
            erreurMessage: '',
            SelectedReferencePaiement: null,
            NeedConnexion: false,
            IsMobile: false,
            ShowModalPointRelais: false,
            IsTablet: false,
            HeaderlightHtml: null,
            FooterLightHtml: null,
            templatesExtracted: false,
            headerDisplayed: false,
            footerDisplayed: false,
            backButton: null,
            ShowTransporteurs: true,
            isStOpenByCta: false,
            wasOpenedByCta: false
        }
    },
    computed: {
        optionsAllPanierVendeur() {
            var options = this.Panier.PaniersVendeurs.flatMap((x) => x.Options)

            return options.filter((x) => x != null && x.IsSelected)
        },
        isConnected() {
            return (
                this.Panier.Client &&
                this.Panier.Client.Reference != null &&
                this.Panier.Client.Reference != 0
            )
        },
        isValidAdress() {
            const hasCodePostal =
                this.Panier.Client.CodePostal != null && this.Panier.Client.CodePostal !== ''

            const hasNom = this.Panier.Client.Nom != null && this.Panier.Client.Nom !== ''

            const hasPrenom = this.Panier.Client.Prenom != null && this.Panier.Client.Prenom !== ''

            const hasVille = this.Panier.Client.Ville != null && this.Panier.Client.Ville !== ''

            return (
                this.Panier.Client.Adresse != null &&
                hasCodePostal &&
                hasVille &&
                hasNom &&
                hasPrenom
            )
        },
        nbArticle() {
            if (!this.Panier || !this.Panier.PaniersVendeurs) {
                return ''
            }
            var nbligne = this.Panier.PaniersVendeurs.flatMap((x) => x.LignesPaniers).length
            return nbligne
        },
        GetReferencePanierVendeurST() {
            var returnValue = -1

            if (this.Panier && this.Panier.PaniersVendeurs) {
                this.Panier.PaniersVendeurs.forEach((pv) => {
                    if (pv.Options) {
                        const option = pv.Options.find((o) => o.Reference == this.refST)
                        if (option) {
                            returnValue = pv.Reference
                        }
                    }
                })
            }

            return returnValue
        },
        HasShoppingTranquille() {
            var returnValue = false

            if (this.Panier?.PaniersVendeurs) {
                this.Panier.PaniersVendeurs.forEach((pv) => {
                    if (pv.Options) {
                        const option = pv.Options.find((o) => o.Reference == this.refST)
                        if (option) {
                            returnValue = option.IsSelected
                        }
                    }
                })
            }
            return returnValue
        },
        CanHaveShoppingTranquille() {
            var returnValue = null

            if (this.Panier.PaniersVendeurs) {
                this.Panier.PaniersVendeurs.forEach((pv) => {
                    if (pv.Options) {
                        const option = pv.Options.find((o) => o.Reference == this.refST)
                        if (option) {
                            returnValue = option
                        }
                    }
                })
            }
            return returnValue
        },
        CanGetCrossSellArticles() {
            return (
                this.Panier &&
                this.Panier.PaniersVendeurs &&
                this.Panier.PaniersVendeurs[0] &&
                this.Panier.PaniersVendeurs[0].LignesPaniers[0]
            )
        }
    },
    async created() {
        if (window.location.hash) {
            showLoader()
        }

        this.IsMobile = $('#panierApp').data('ismobile') === 1
        this.IsTablet = $('#panierApp').data('istablet') === 1

        document.getElementById('panierApp').style.display = ''
        const urlParams = new URLSearchParams(window.location.search)
        this.referencePaiement = urlParams.get('rp')

        await this.LoadPanier()

        await this.LoadHeader()

        await this.LoadFooter()

        document.addEventListener('header-goback', this.goBack)

        document.addEventListener('cross-sell-ajout-panier', this.HandlerAjoutPanierCrossSell)

        this.StartMagicZoom()
        if (this.Panier && this.Panier.PaniersVendeurs.length > 0) {
            this.JumpToStepFromHash()
        }

        var _self = this
        window.onpopstate = function () {
            _self.JumpToStepFromHash()
        }

        var paiement = this.GetPaiement()

        this.EvalJavascriptPaiement(paiement)

        // l'event GA4 view cart n'est pas déclenché si on revient au panier avec un HashTag
        if (window.location.hash == '') {
            window.dispatchEvent(new Event('view_cart'))
        }
        initCopyCodePromoHandler()
        // récupération du paramètre CP pour le code promo
        const params = new URLSearchParams(window.location.search)

        // Vérifie si le paramètre "cp" est présent
        if (params.has('cp')) {
            // Récupère sa valeur
            this.CodePromo = params.get('cp')
            this.UpdateCodePromo()
        }

        if (this.Step === this.Steps.Shopping.Value) {
            this.GetCrossSellArticles()
        }
    },
    mounted() {
        hideLoader()
    },
    beforeUnmount() {
        document.removeEventListener('header-goback', this.goBack)
    },
    methods: {
        async displayApplePay() {
            if (!this.Panier.Paiements) {
                return
            }

            /// ========= APPLE PAY
            /// NOTE: vérifie si le paiement Apple Pay est activé et vérifie si le paiement ApplePay est disponible pour l'utilisateur puis met à jour la liste des paiements du panier
            /// NOTE: ne pas utiliser cette méthode pour gérer les moyens de paiements du panier (réservé ApplePay)
            const paiementApplePay = this.Panier.Paiements.find(
                (p) => p.Reference === 25 /* || p.Libelle == "ApplePay"*/
            )
            if (
                paiementApplePay &&
                (!window.ApplePaySession || !window.ApplePaySession.canMakePayments())
            ) {
                this.Panier.Paiements = this.Panier.Paiements.filter((p) => p.Reference != 25)
            }
            /// =========
        },
        async LoadPanier() {
            try {
                this.ToogleButtons()
                this.UpdatePanier(await PanierPremiumService.LoadPanier(this.referencePaiement))
                this.ToogleButtons()
            } catch {
                this.hasError = true
            } finally {
                this.IsInitialLoad = false
            }
        },
        async SupprimerLignePanier(panierLigneId) {
            this.ToogleButtons()
            this.UpdatePanier(await PanierPremiumService.DeleteLignePanier(panierLigneId))
            this.ToogleButtons()
            this.GetCrossSellArticles()
        },
        async UpdateTransport(referencePanierVendeur, referenceTransport) {
            this.ToogleButtons()
            this.UpdatePanier(
                await PanierPremiumService.UpdateTransport(
                    referencePanierVendeur,
                    referenceTransport
                )
            )
            this.ToogleButtons()
        },
        async UpdatePaiement(referenceModePaiement) {
            window.dispatchEvent(new Event('add_payment_info'))

            if (this.GetPaiement().Reference != referenceModePaiement) {
                this.ToogleButtons()
                // on ne fait la mise à jour que s'il y a changement

                this.UpdatePanier(
                    await PanierPremiumService.UpdatePaiement(
                        this.referencePaiement,
                        referenceModePaiement
                    )
                )

                this.SelectedReferencePaiement = referenceModePaiement

                Vue.nextTick(() => {
                    this.EvalJavascriptPaiement(this.GetPaiement())
                })

                this.ToogleButtons()
            }
        },
        async UpdateAvoirs() {
            this.onValidationScriptWasRun = false
            this.ToogleButtons()
            this.UpdatePanier(
                await PanierPremiumService.UpdateAvoirs(
                    this.referencePaiement,
                    this.Panier.Avoirs.IsSelected
                )
            )
            await this.UpdatePaiement(this.GetPaiement().Reference)
            this.SelectedReferencePaiement = this.GetPaiement().Reference
            this.ToogleButtons()
        },
        async UpdateBonsAchat() {
            this.ToogleButtons()
            this.UpdatePanier(
                await PanierPremiumService.UpdateBonsAchat(
                    this.referencePaiement,
                    this.Panier.BonsAchat.IsSelected
                )
            )
            await this.UpdatePaiement(this.GetPaiement().Reference)
            this.SelectedReferencePaiement = referenceModePaiement
            this.ToogleButtons()
        },
        async UpdateCodePromo() {
            this.ToogleButtons()
            this.ResultatCodePromo = null

            var reponse = await PanierPremiumService.UpdateCodePromo(
                this.Panier.CodePromo != null,
                this.CodePromo
            )

            if (this.Panier.CodePromo == null) {
                switch (reponse.Result) {
                    case 2:
                        // le client ne reviendra pas à la page panier, l'ajout du code promo déclenche aussi un begin checkout
                        window.dispatchEvent(new Event('begin_checkout'))
                        this.Connexion('/inscription?redirect=Panier%2F%3Fcp%3D' + this.CodePromo)
                        break

                    case 1:
                        this.ResultatCodePromo = $t('CODE_INVALIDE')
                        break
                }
            }

            this.UpdatePanier(reponse)
            this.ToogleButtons()
        },
        async UpdateOption(referencePanierVendeur, referenceOption) {
            const option = this.GetOption(referencePanierVendeur, referenceOption)

            this.ToogleButtons()
            this.UpdatePanier(
                await PanierPremiumService.UpdateOption(
                    referencePanierVendeur,
                    referenceOption,
                    option.IsSelected
                )
            )
            this.ToogleButtons()
        },
        async ChangerAdresse() {
            this.ShowTransporteurs = true
            this.ToogleButtons()
            this.UpdatePanier(
                await PanierPremiumService.UpdateAdresseLivraison(this.Panier.Client),
                false
            )
            this.ToogleButtons()
        },
        async LoadPointRelais(referencePanierVendeur, isGeoloc) {
            var transport = this.GetTransport(referencePanierVendeur)

            if (!transport) {
                return
            }

            var panierVendeur = this.Panier.PaniersVendeurs.find(
                (x) => x.Reference == referencePanierVendeur
            )

            if (!panierVendeur) {
                return
            }

            const currentPointRelais = this.Panier.PaniersVendeurs.find(
                (x) => x.Reference === referencePanierVendeur
            )?.Relais

            // Gestion du point relais déjà sélectionné lors de l'ouverture de la map
            if (
                !isGeoloc &&
                currentPointRelais &&
                currentPointRelais.Latitude !== 0 &&
                currentPointRelais.Longitude !== 0
            ) {
                this.RecherchePointRelais.PointRelaisType = transport.PointRelaisType

                const copieRecherchePR = JSON.parse(JSON.stringify(this.RecherchePointRelais))

                delete copieRecherchePR.Adresse
                delete copieRecherchePR.CodePostal
                delete copieRecherchePR.Ville

                copieRecherchePR.Latitude = currentPointRelais.Latitude
                copieRecherchePR.Longitude = currentPointRelais.Longitude

                this.PointRelais = []

                this.PointRelais = await PanierPremiumService.ListPointRelais(
                    copieRecherchePR,
                    panierVendeur.Vendeur.Reference
                )

                this.PointRelais.forEach((pr) => {
                    pr.AfficherHoraire = false

                    if (currentPointRelais && currentPointRelais.Identifiant === pr.Identifiant) {
                        pr.IsSelected = true
                    }
                })
                return
            }

            this.RecherchePointRelais.PointRelaisType = transport.PointRelaisType

            if (!this.RecherchePointRelais.CodePostal) {
                this.hasErrorPointRelais = true
                this.erreurMessage =
                    'Le code postal est requis pour finaliser votre recherche. Veuillez le saisir avant de rechercher.'
                return
            }

            const copieRecherchePR = JSON.parse(JSON.stringify(this.RecherchePointRelais))

            if (isGeoloc) {
                delete copieRecherchePR.Adresse
                delete copieRecherchePR.CodePostal
                delete copieRecherchePR.Ville
            } else {
                delete copieRecherchePR.Longitude
                delete copieRecherchePR.Latitude
            }
            this.ToogleButtons()
            this.PointRelais = []

            this.PointRelais = await PanierPremiumService.ListPointRelais(
                copieRecherchePR,
                panierVendeur.Vendeur.Reference
            )

            if (this.PointRelais.length === 0) {
                this.hasErrorPointRelais = true
                this.erreurMessage =
                    "L'adresse saisie semble incorrecte. Veuillez vérifier et la retaper. Parfois, les adresses trop longues, contenant des caractères non valides peuvent causer des problèmes."
                this.ToogleButtons()
                return
            }

            this.PointRelais.forEach((pr) => {
                pr.AfficherHoraire = false

                if (currentPointRelais && currentPointRelais.Identifiant === pr.Identifiant) {
                    pr.IsSelected = true
                }
            })

            this.ToogleButtons()
        },
        async UpdatePointRelais(relai) {
            this.UpdatePanier(
                await PanierPremiumService.UpdatePointRelais(
                    relai.MoyenLivraison,
                    this.SelectedReferenceVendeur,
                    relai.Identifiant
                )
            )
        },

        GetTransport(referencePanierVendeur) {
            const panierVendeur = this.GetPanierVendeur(referencePanierVendeur)

            if (panierVendeur) {
                const transport = panierVendeur.Transports.find((t) => t.IsSelected)

                if (!transport) {
                    console.error('Aucun transport par défaut')
                    //throw new Error("Aucun transport par défaut");
                    return null
                }

                return transport
            }
        },

        GetGroupedTransports(referencePanierVendeur) {
            let groupBy = function (xs, key) {
                return xs.reduce(function (rv, x) {
                    ;(rv[x[key]] = rv[x[key]] || []).push(x)
                    return rv
                }, {})
            }
            const panierVendeur = this.GetPanierVendeur(referencePanierVendeur)
            let returnValue = []
            if (panierVendeur) {
                const groupedTransport = groupBy(panierVendeur.Transports, 'TransportGroupName')
                Object.keys(groupedTransport).forEach((e) => {
                    let firstElement = groupedTransport[e][0]
                    let isSelected = groupedTransport[e].reduce((a, c) => a || c.IsSelected, false)
                    firstElement.Libelle = firstElement.TransportGroupName
                    firstElement.IsSelected = isSelected
                    returnValue.push(firstElement)
                })
            }

            return returnValue
        },

        GetOption(referencePanierVendeur, referenceOption) {
            const panierVendeur = this.GetPanierVendeur(referencePanierVendeur)

            if (panierVendeur) {
                const option = panierVendeur.Options.find((o) => o.Reference == referenceOption)

                return option
            }
        },

        GetPaiement() {
            const paiement = this.Panier.Paiements.find((p) => p.IsSelected)
            if (!paiement) {
                return {
                    Libelle: this.Panier.Avoirs.IsSelected ? 'Avoir' : "Bon d'achat"
                }
            }
            return paiement
        },

        GetPanierVendeur(referencePanierVendeur) {
            const panierVendeur = this.Panier.PaniersVendeurs.find(
                (pv) => pv.Reference == referencePanierVendeur
            )

            if (!panierVendeur) {
                throw new Error('Panier vendeur non trouvé')
            }

            return panierVendeur
        },

        UpdatePanier(response, refreshRelaisButton = true) {
            const _self = this

            this.Panier = response.Panier
            this.Script = response.Script
            this.Result = response.Result

            if (this.Panier.CodePromo != null) {
                this.CodePromo = this.Panier.CodePromo.Libelle
            } else {
                this.CodePromo = ''
            }

            if (this.Panier.PaniersVendeurs) {
                this.Panier.PaniersVendeurs.forEach((pv, index) => {
                    var transport = _self.GetTransport(pv.Reference)

                    if (refreshRelaisButton && transport) {
                        pv.RelaisIsChecked = transport.IsPointRelais
                    }

                    if (this.IsInitialLoad) {
                        this.AffichageLivraisonPanierVendeur.push({
                            ReferencePanierVendeur: pv.Reference,
                            AffichageLivraison:
                                index == 0
                                    ? this.AffichageLivraisons.Formulaire
                                    : this.AffichageLivraisons.None
                        })
                    }
                })
            }
            this.displayApplePay()
        },

        GetAffichageLivraisonPanierVendeur(referencePanierVendeur) {
            const affichageLivraison = this.AffichageLivraisonPanierVendeur.find(
                (x) => x.ReferencePanierVendeur == referencePanierVendeur
            )

            if (affichageLivraison) {
                return affichageLivraison.AffichageLivraison
            }

            return this.AffichageLivraisons.None
        },

        SetAffichageLivraisonPanierVendeur(panierVendeur, nextPanierVendeur) {
            let affichageLivraison

            if (panierVendeur) {
                affichageLivraison = this.AffichageLivraisonPanierVendeur.find(
                    (x) => x.ReferencePanierVendeur == panierVendeur.Reference
                )

                if (affichageLivraison) {
                    affichageLivraison.AffichageLivraison = this.AffichageLivraisons.Resume
                }
            }

            if (nextPanierVendeur) {
                affichageLivraison = this.AffichageLivraisonPanierVendeur.find(
                    (x) => x.ReferencePanierVendeur == nextPanierVendeur.Reference
                )

                if (affichageLivraison && affichageLivraison != this.AffichageLivraisons.Resume) {
                    affichageLivraison.AffichageLivraison = this.AffichageLivraisons.Formulaire
                }
            }
        },

        ClickBtnModifierLivraison(referencePanierVendeur) {
            this.Step = this.Steps.Livraison.Value

            const affichageLivraison = this.AffichageLivraisonPanierVendeur.find(
                (x) => x.ReferencePanierVendeur == referencePanierVendeur
            )

            if (affichageLivraison) {
                affichageLivraison.AffichageLivraison = this.AffichageLivraisons.Formulaire
            }
        },
        async OpenModalPointRelais(referencePanierVendeur) {
            if (this.RecherchePointRelais.IsFirstLoad) {
                this.RecherchePointRelais.IsFirstLoad = false

                this.RecherchePointRelais.Adresse = this.Panier.Client.Adresse
                this.RecherchePointRelais.CodePostal = this.Panier.Client.CodePostal
                this.RecherchePointRelais.Ville = this.Panier.Client.Ville
            }

            await this.LoadPointRelais(referencePanierVendeur, false)

            this.SelectedReferenceVendeur = referencePanierVendeur

            this.ShowModalPointRelais = !this.ShowModalPointRelais
        },

        LocaliserRelaisGeo() {
            this.hasErrorPointRelais = false
            this.LoadPointRelais(this.SelectedReferenceVendeur, true)
        },

        LocaliserRelaisAdresse() {
            this.hasErrorPointRelais = false
            this.LoadPointRelais(this.SelectedReferenceVendeur, false)
        },

        ToogleButtons() {
            this.IsLoading = !this.IsLoading
        },
        ShowMoreProduct() {
            this.ShowLineProduct = !this.ShowLineProduct

            if (this.ShowLineProduct) {
                this.libelleShowMoreProduct = $t('VOIR_MOINS')
            } else {
                this.libelleShowMoreProduct = $t('VOIR_PLUS')
            }
        },
        ChangeTransportSelected(referencePanierVendeur) {
            var transport = this.GetTransport(referencePanierVendeur)

            if (transport) {
                this.TransportSelected = transport
            }
        },

        DisplayCodePromo() {
            this.IsDisplayCP = !this.IsDisplayCP
        },

        TotalShoppingTranquille(referencePanierVendeur) {
            if (referencePanierVendeur != null || referencePanierVendeur != undefined) {
                var st = this.GetOption(referencePanierVendeur, this.refST)
                return st.MontantTtc
            } else {
                var returnValue = 0

                if (this.Panier.PaniersVendeurs) {
                    this.Panier.PaniersVendeurs.forEach((pv) => {
                        const option = pv.Options.find((o) => o.Reference == this.refST)
                        returnValue = returnValue + this.TotalShoppingTranquille(pv.Reference)
                    })
                }

                return returnValue
            }
        },

        CloseModalST() {
            if (this.isStOpenByCta) {
                this.isStOpenByCta = false
                $('#modal-shoopingtranquille').modal('hide')
                return
            }
            if (this.NeedConnexion) {
                this.Connexion()
                return
            }
            this.Step = this.Steps.Livraison.Value
        },

        //affichage des modes de livraison en fonction du type choisi
        ToggleDeliveryMode(referencePanierVendeur, isRelais) {
            this.ShowTransporteurs = true

            var panierVendeur = this.Panier.PaniersVendeurs.find(
                (x) => x.Reference == referencePanierVendeur
            )

            if (panierVendeur) {
                panierVendeur.RelaisIsChecked = isRelais
                this.domicileIsChecked = false
            }

            this.$forceUpdate()
        },

        Connexion(redirect = '/inscription?redirect=Panier%2F%23livraison') {
            window.location.href = redirect
        },

        async ValiderPanier() {
            await this.LoadPanier()

            if (!this.SelectedReferenceVendeur) {
                this.SelectedReferenceVendeur = this.Panier.PaniersVendeurs[0].Reference
            }

            switch (this.Step) {
                case this.Steps.Shopping.Value:
                    window.dispatchEvent(new Event('begin_checkout'))

                    this.NeedConnexion = !this.isConnected || !this.isValidAdress

                    window.scrollTo(0, 0)

                    if (
                        this.HasShoppingTranquille ||
                        !this.CanHaveShoppingTranquille ||
                        this.wasOpenedByCta
                    ) {
                        if (this.NeedConnexion) {
                            this.Connexion()
                            return
                        }

                        this.previousStep = this.Step

                        //affiche étape suivante
                        this.Step = this.Steps.Livraison.Value // "basketStep2";
                    } else {
                        this.ShowModalShoppingTranquille()
                    }

                    break

                case this.Steps.Livraison.Value:
                    this.onValidationScriptWasRun = false

                    if (!this.ValiderLivraisonDomicile()) {
                        // Ouverture du formulaire de l'adresse de livraison
                        $('.basketLivraison__btnChangeAdresse')[0].click()
                        return
                    }

                    window.dispatchEvent(new Event('add_shipping_info'))
                    if (this.VerifTransport()) {
                        var index = this.Panier.PaniersVendeurs.findIndex(
                            (x) => x.Reference == this.SelectedReferenceVendeur
                        )

                        var panierVendeur = this.Panier.PaniersVendeurs[index]
                        var nextPanierVendeur = this.Panier.PaniersVendeurs[index + 1]

                        this.SetAffichageLivraisonPanierVendeur(panierVendeur, nextPanierVendeur)

                        if (nextPanierVendeur) {
                            this.SelectedReferenceVendeur = nextPanierVendeur.Reference
                        } else {
                            this.SetMoyenPaiementByDefault()
                            this.previousStep = this.Step
                            this.Step = this.Steps.Paiement.Value
                            window.dispatchEvent(new Event('add_payment_info'))
                            Vue.nextTick(() => {
                                this.EvalJavascriptPaiement(this.GetPaiement())
                            })
                        }
                    }
                    this.libelleShowMoreProduct = $t('VOIR_PLUS')
                    this.ShowLineProduct = false
                    break

                case this.Steps.Paiement.Value:
                    this.previousStep = this.Step
                    window.dispatchEvent(new Event('start_paiement'))
                    if (this.Panier.IsPaiementDiffere) {
                        window.location.href =
                            '/Paiement/PayerClubPaiementPremium?refPaiement=' +
                            this.referencePaiement
                    } else {
                        window.location.href = '/Paiement/PayerPremium'
                    }
                    break
            }
            this.ScrollToStep()
        },
        HandleTestABPopIn() {
            if (!this.isConnected || !this.isValidAdress) {
                this.Connexion()
                return
            }

            this.previousStep = this.Step
            this.Step = this.Steps.Livraison.Value
        },
        GetLibelleDateTransport(transport) {
            var returnValue = ''

            let demain = new Date()
            demain.setHours(0, 0, 0, 0)
            demain.setDate(demain.getDate() + 1)
            let dateliv = new Date(
                transport.DateLivraisonEstimee.split('/')[2],
                transport.DateLivraisonEstimee.split('/')[1] - 1,
                transport.DateLivraisonEstimee.split('/')[0]
            )
            if (demain.toDateString() == dateliv.toDateString()) {
                returnValue = $t('DEMAIN')
            } else {
                returnValue = $t('LE') + ' ' + transport.DateLivraisonEstimee
            }

            return returnValue
        },

        VerifTransport() {
            const panierVendeur = this.GetPanierVendeur(this.SelectedReferenceVendeur)

            if (!panierVendeur) {
                return false
            }

            var transport = panierVendeur.Transports.find((x) => x.IsSelected)

            if (!transport) {
                return false
            }

            if (transport.IsPointRelais && panierVendeur.Relais) {
                return true
            }

            if (!transport.IsPointRelais) {
                return true
            }
            return false
        },

        HasPointRelais(referencePanierVendeur) {
            const panierVendeur = this.GetPanierVendeur(referencePanierVendeur)

            if (panierVendeur) {
                var transport = panierVendeur.Transports.find((x) => x.IsPointRelais)

                if (transport) {
                    return true
                }
            }

            return false
        },

        HasDomicile(referencePanierVendeur) {
            const panierVendeur = this.GetPanierVendeur(referencePanierVendeur)

            if (panierVendeur) {
                var transport = panierVendeur.Transports.find((x) => !x.IsPointRelais)

                if (transport) {
                    return true
                }
            }

            return false
        },

        BackPointRelais() {
            this.Step = this.Steps.Livraison.Value
        },

        SupprimerCommande(event) {
            if (!this.SendSupprimerCommande) {
                event.preventDefault()

                $('#modal-supprimerCommande').modal({
                    keyboard: true,
                    show: true
                })
            }
        },

        JumpToStepFromHash() {
            this.Step = this.Steps.Shopping.Value

            if (this.Panier.IsPaiementDiffere) {
                this.SetMoyenPaiementByDefault()
                this.Step = this.Steps.Paiement.Value
                return
            }

            for (let stepParam in this.Steps) {
                let step = this.Steps[stepParam]

                if (step.Hash == window.location.hash) {
                    if (step.Value != this.Steps.Shopping.Value && !this.isConnected) {
                        this.Connexion()
                        break
                    }
                    this.Step = step.Value
                    break
                }
            }

            this.DisplayHeader()
            this.ScrollToStep()
            this.SetMoyenPaiementByDefault()
        },

        StartMagicZoom: function () {
            Vue.nextTick(function () {
                // eslint-disable-next-line no-undef
                MagicZoom.start()
            })
        },
        ScrollToStep() {
            let elementId = ''
            for (const key in this.Steps) {
                if (this.Steps[key].Value === this.Step) {
                    elementId = this.Steps[key].elementId
                    break
                }
            }

            if (elementId === '') {
                return
            }

            // détermination de la hauteur du header

            let height = 0
            if (!document.querySelector('.jHeaderMobile')) {
                const header = document.querySelector('header')
                height = header.getBoundingClientRect().height
            }

            Vue.nextTick(function () {
                const element = document.getElementById(elementId)
                if (element) {
                    const rect = element.getBoundingClientRect()
                    const scrollLeft = window.scrollX + rect.left
                    const scrollTop = window.scrollY + rect.top - height
                    window.scrollTo({
                        top: scrollTop,
                        left: scrollLeft,
                        behavior: 'smooth' // ou 'auto' si tu ne veux pas d’animation
                    })
                } else {
                    console.warn(`Élément avec l'ID "${elementId}" non trouvé.`)
                }
            })
        },
        GetTransports(panierVendeur) {
            const relaisStandard = panierVendeur.Transports.filter((x) => x.PointRelaisType === 0)

            // Si un seul relais standard, il n'y a rien à faire
            if (relaisStandard.length <= 1) {
                return panierVendeur.Transports
            }

            const allRelais = panierVendeur.Transports.filter((x) => x.PointRelaisType !== 0)

            const selectedTransport = relaisStandard.find((x) => x.IsSelected)

            // Si aucun transport relais standard sélectionné, on ajoute le premier par défaut
            if (!selectedTransport) {
                return [relaisStandard[0], ...allRelais]
            }

            return [selectedTransport, ...allRelais]
        },
        ValiderLivraisonDomicile() {
            const panierVendeur = this.GetPanierVendeur(this.SelectedReferenceVendeur)

            if (!panierVendeur) {
                return false
            }

            var transport = panierVendeur.Transports.find((x) => x.IsSelected)

            if (!transport) {
                return false
            }

            if (
                (!transport.NeedValideAdresseClient && !transport.NeedValideTelephoneClient) ||
                (this.Panier.Client.HasAdresseValide && this.Panier.Client.HasTelephoneValide)
            ) {
                return true
            }

            if (
                (transport.NeedValideAdresseClient &&
                    !this.Panier.Client.HasAdresseValide &&
                    this.Panier.Client.Telephone) ||
                (transport.NeedValideTelephoneClient && !this.Panier.Client.HasTelephoneValide)
            ) {
                return false
            }

            return true
        },
        SetMoyenPaiementByDefault() {
            if (this.SelectedReferencePaiement) {
                return
            }

            const selectedPaiement = this.Panier.Paiements.find((x) => x.IsSelected)

            if (selectedPaiement) {
                this.SelectedReferencePaiement = selectedPaiement.Reference
                return
            }

            const paiementCB = this.Panier.Paiements.find((x) => x.Reference === 12)

            if (!paiementCB) {
                return
            }

            this.SelectedReferencePaiement = paiementCB.Reference
        },
        EvalJavascriptPaiement(paiement) {
            if (
                (!paiement.JsScriptOnActivation && !paiement.JsScriptOnValidation) ||
                this.Step !== this.Steps.Paiement.Value
            ) {
                return
            }

            if (!this.onActivationScriptWasRun) {
                eval(paiement.JsScriptOnActivation)
                this.onActivationScriptWasRun = true
            }

            if (!this.onValidationScriptWasRun) {
                let script = paiement.JsScriptOnValidation

                // Gestion affichage boutons Paypal
                if (paiement.Libelle === 'Paypal' && this.IsMobile) {
                    script = paiement.JsScriptOnValidation.replace(
                        "layout: 'horizontal'",
                        "layout: 'vertical'"
                    )
                }
                eval(script)
                this.onValidationScriptWasRun = true
            }
        },
        ShowModalShoppingTranquille() {
            $('#modal-shoopingtranquille').modal({
                keyboard: true,
                show: true
            })
        },

        ShowModalShoppingTranquilleByCta() {
            this.isStOpenByCta = true
            this.wasOpenedByCta = true
            $('#modal-shoopingtranquille').modal({
                keyboard: true,
                show: true
            })
        },
        LoadHeader() {
            $.get(
                '/Layout/HeaderLight?isMobile=' +
                    this.IsMobile +
                    '&culture=' +
                    $('html').attr('lang')
            ).then((html) => {
                this.HeaderlightHtml = html
            })
        },
        DisplayHeader() {
            if (!this.HeaderlightHtml || this.headerDisplayed) return

            if (this.IsMobile) {
                document
                    .querySelector('.header-mobile')
                    .insertAdjacentHTML('beforebegin', this.HeaderlightHtml)
                this.adjustAnchorMobForMode()
                $('#nav-mob').remove()

                $('.header-panier').show()
            } else if (this.IsTablet) {
                document
                    .querySelector('.header-mobile')
                    .insertAdjacentHTML('beforebegin', this.HeaderlightHtml)
                this.adjustAnchorMobForMode()
                $('#nav-mob').remove()

                $('.header-panier').show()
            } else {
                document
                    .querySelector('header')
                    .insertAdjacentHTML('beforebegin', this.HeaderlightHtml)
                $('#header').remove()
                $('.header-panier').show()
            }
            this.headerDisplayed = true
            this.$nextTick(() => {
                this.initBackButton()
            })
        },
        LoadFooter() {
            $.get('/Layout/FooterLight?culture=' + $('html').attr('lang')).then((html) => {
                this.FooterLightHtml = html
            })
        },
        DisplayFooter() {
            if (!this.FooterLightHtml || this.footerDisplayed) return
            if (this.IsTablet) {
                $('footer').empty()
                document
                    .querySelector('#anchorMob')
                    .insertAdjacentHTML('afterend', this.FooterLightHtml)
            } else {
                $('footer').empty()
                document
                    .querySelector('footer')
                    .insertAdjacentHTML('afterbegin', this.FooterLightHtml)
            }
            this.footerDisplayed = true
        },

        /**
         *
         * Padding de anchorMob
         */
        adjustAnchorMobForMode() {
            this.$nextTick(() => {
                const anchorMob = document.querySelector('#anchorMob')
                if (anchorMob && this.Step > this.Steps.Shopping.Value) {
                    anchorMob.style.paddingTop = '0'
                }
            })
        },
        initBackButton() {
            this.backButton = document.querySelector('.sep-header-light__back')

            if (this.backButton) {
                this.updateBackButton()
                return
            }

            let attempts = 0
            const maxAttempts = 30

            const interval = setInterval(() => {
                this.backButton = document.querySelector('.sep-header-light__back')
                attempts++

                if (this.backButton) {
                    clearInterval(interval)
                    this.updateBackButton()
                } else if (attempts >= maxAttempts) {
                    clearInterval(interval)
                    const allButtons = document.querySelectorAll('button')
                    allButtons.forEach((btn, i) => {})
                }
            }, 100)
        },
        updateBackButton() {
            if (!this.backButton) {
                this.backButton = document.querySelector('.sep-header-light__back')
            }

            if (!this.backButton) {
                return
            }
            const shouldShow = this.Panier.IsPaiementDiffere
            this.backButton.style.display = shouldShow ? 'none' : 'block'
        },
        //cta précédent
        goBack() {
            if (this.Step > this.Steps.Shopping.Value) {
                // > 0
                switch (this.Step) {
                    case this.Steps.Livraison.Value: // 1
                        location.href =
                            document.location.origin +
                            document.location.pathname +
                            document.location.search
                        break
                    case this.Steps.PointRelais.Value: // 2
                        this.Step = this.Steps.Livraison.Value //  1
                        break
                    case this.Steps.Paiement.Value: // 3
                        this.Step = this.Steps.Livraison.Value // 1
                        break
                }
            }
        },
        HandleDisplayChangeAdresse() {
            this.ShowTransporteurs = false
        },
        GetCrossSellArticles() {
            if (!this.CanGetCrossSellArticles) {
                return
            }

            const { RefModele, Couleur, Taille } =
                this.Panier.PaniersVendeurs[0].LignesPaniers.find(
                    (x) =>
                        x.Prix.PrixTtc ===
                        Math.max(
                            ...this.Panier.PaniersVendeurs[0].LignesPaniers.map(
                                (l) => l.Prix.PrixTtc
                            )
                        )
                )

            $.get(
                '/PanierApi/GetCrossSellArticles?refModele=' +
                    RefModele +
                    '&codeCouleur=' +
                    Couleur.Reference +
                    '&taille=' +
                    Taille.Reference
            ).then((result) => {
                if (!result) {
                    return
                }

                $('.cross-sell-container').html(result)

                crossSell.saveCrossSellArticles()

                carousel.activerCarrouselCrossSell()

                InitWishListEvent()

                import('Modules/produit').then((produit) => {
                    produit.default.setEvent('.j_cross-sell')
                })

                modal.miseAjourParClassCss(
                    'modal-produit-catalogue',
                    window.location.origin + '/catalogue/' + '?modal=produit',
                    function () {
                        import('Modules/produit').then((produit) => {
                            produit.default.init('#modal-produit', '#modal-produit-dialog', {
                                bypassAddPanier: true,
                                addPanierCallback: () =>
                                    document.dispatchEvent(new Event('cross-sell-ajout-panier'))
                            })
                        })
                    }
                )
            })
        },
        async HandlerAjoutPanierCrossSell() {
            if (!this.Panier.PaniersVendeurs) {
                location.reload()
                return
            }

            await this.LoadPanier()

            if (this.Step === this.Steps.Shopping.Value) {
                this.GetCrossSellArticles()
            }
        }
    },

    watch: {
        Script(newScript) {
            eval(newScript)
        },

        Step(value, oldValue) {
            var hash = ''

            for (let stepParam in this.Steps) {
                let step = this.Steps[stepParam]

                if (step.Value == value) {
                    hash = step.Hash
                    break
                }
            }

            if (this.Step > this.Steps.Shopping.Value && oldValue === this.Steps.Shopping.Value) {
                this.DisplayHeader()
                this.DisplayFooter()
            }
            if (!this.IsPaiementDiffere && this.headerDisplayed) {
                this.updateBackButton()
            }

            if (value === this.Steps.Livraison.Value && !this.isValidAdress) {
                this.Connexion()
            }

            if (value === this.Steps.Livraison.Value && oldValue > value) {
                // Gère le retour en arrière lors du paiement en remettant la sélection du mode de livraison
                this.Panier.PaniersVendeurs.forEach((x) =>
                    this.ClickBtnModifierLivraison(x.Reference)
                )
                this.SelectedReferenceVendeur = this.Panier.PaniersVendeurs[0].Reference
            }

            if (hash && hash != window.location.hash) {
                history.pushState(
                    {},
                    document.title,
                    document.location.origin +
                        document.location.pathname +
                        document.location.search +
                        hash
                )
            }
            if (value === this.Steps.Shopping.Value) {
                this.GetCrossSellArticles()
            } else {
                $('.cross-sell').remove()
            }
        },

        nbArticle(newValue) {
            $('.basket-count').html(newValue)

            if (newValue === '') {
                $('.basket-count').parent('span').removeClass('numb-prod')
            }
        },
        HeaderlightHtml(value) {
            if (this.Step === this.Steps.Shopping.Value) {
                return
            }

            this.DisplayHeader()
        },
        FooterLightHtml(value) {
            if (this.Step === this.Steps.Shopping.Value) {
                return
            }

            this.DisplayFooter()
        }
    }
})

document.addEventListener('DOMContentLoaded', () => {
    let screenWidth = window.innerWidth
    let basket = document.querySelector('.basket')
    let headerMob = document.getElementById('nav-mob')
    let header = document.querySelector('.zone-header')

    let headerlight = document.querySelector('.sep-header-light')
    let reassuranceMobHeight = 272
    let reassuranceTabHeight = 170
    let reassuranceHeight = 224

    if (screenWidth >= 1024 && header && !headerlight) {
        let headerHeight = header.offsetHeight

        let basketHeight = window.innerHeight - (headerHeight + reassuranceHeight)
        basket.style.minHeight = basketHeight + 'px'
    } else if (screenWidth < 1024 && screenWidth >= 600 && headerMob) {
        let headBanner = document.querySelector('.headBanner')
        let headerTabHeight = headerMob.offsetHeight
        let basketHeightMob

        if (headBanner) {
            let headBannerHeight = headBanner.offsetHeight
            basketHeightMob =
                window.innerHeight - (headerTabHeight + reassuranceTabHeight + headBannerHeight)
        } else {
            basketHeightMob = window.innerHeight - (headerTabHeight + reassuranceTabHeight)
        }

        basket.style.minHeight = basketHeightMob + 'px'
    }

    if (screenWidth >= 1024 && headerlight) {
        let headerlightHeight = headerlight.offsetHeight
        let basketHeight = window.innerHeight - (reassuranceHeight + headerlightHeight)
        basket.style.minHeight = basketHeight + 'px'
    }
})

master.process()

/**
 * Modal CRO
 */

if ($('#panierApp').data('cro') === 1) {
    new CRO().init()
}
